// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty_empty__AbE8_","body":"empty_body__s2QO8","title":"empty_title__NXsFg","description":"empty_description__AoiKG","actions":"empty_actions__a3nhX"};